import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class PetTypeService {
  getAll() {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/petTypes`, options);
  }
}

export default PetTypeService;
